import React from "react"
import Select from "react-select"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "../ThemeConsumer"

const ModernFloatLabelSelect = ({
  theme,
  label,
  options,
  onChange,
  value,
  defaultValue = true,
  customStyles,
  error,
  margin,
  disabled,
  ...props
}) => {
  const marginClass = theme[`margin_${margin}`]
  return (
    <div
      className={classnames(theme.containerSelect, marginClass, {
        [theme.invalid]: error
      })}
    >
      <label className={theme.label}>{label}</label>
      <Select
        {...props}
        options={options}
        defaultValue={defaultValue ? options[0] : null}
        classNamePrefix="react-select"
        isSearchable={false}
        onChange={onChange}
        value={value}
        styles={customStyles}
        placeholder={label}
        isDisabled={disabled}
      />

      {error && <span className={theme.error}>{error}</span>}
    </div>
  )
}

ModernFloatLabelSelect.propTypes = {
  theme: PropTypes.shape({
    containerSelect: PropTypes.string,
    containerSpan: PropTypes.string,
    spanSelect: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string,
    invalid: PropTypes.string
  }),
  defaultValue: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.object,
  customStyles: PropTypes.object,
  error: PropTypes.string,
  margin: PropTypes.string,
  disabled: PropTypes.bool
}

export default ThemeConsumer("UIModernSelect")(ModernFloatLabelSelect)



// WEBPACK FOOTER //
// ./src/shared/components/ModernFloatLabelSelect/index.js